/**
 * Retention / anti-disintermediation product events.
 * Names are the contract for Growth, Trust & Safety, and admin snapshot.
 */
export const RETENTION_EVENTS = {
  pairFeeQuoted: 'retention.pair_fee_quoted',
  checkinStarted: 'retention.checkin_started',
  checkinCompleted: 'retention.checkin_completed',
  contactNudgeShown: 'retention.contact_nudge_shown',
  coverageValueViewed: 'retention.coverage_value_viewed',
  handoverQrShown: 'retention.handover_qr_shown',
  handoverVerified: 'retention.handover_presence_verified',
} as const

export type RetentionEventName = (typeof RETENTION_EVENTS)[keyof typeof RETENTION_EVENTS]
